export default "__VITE_ASSET__B531pqym__"